import { render } from "./heroComponent.vue?vue&type=template&id=188bcb82"
import script from "./heroComponent.vue?vue&type=script&lang=js"
export * from "./heroComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__